import { useState } from 'react';

interface FAQAccordionProps {
  question: string;
  answer: string;
}

export default function FAQAccordion({ question, answer }: FAQAccordionProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-background-200/70">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between py-5 text-left cursor-pointer group"
      >
        <span className="text-[15px] md:text-base font-medium text-foreground-800 pr-6 leading-snug transition-colors group-hover:text-primary-600">
          {question}
        </span>
        <span
          className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
            open ? 'bg-primary-600 text-white rotate-180' : 'bg-background-100 text-foreground-500'
          }`}
        >
          <i className="ri-arrow-down-s-line text-base"></i>
        </span>
      </button>
      {open && (
        <div className="pb-6">
          <p className="text-[14px] text-foreground-500 leading-relaxed font-light max-w-2xl">{answer}</p>
        </div>
      )}
    </div>
  );
}